import { Col, Card, Row } from 'react-bootstrap';
import useLeadsStore from '../../../store/LeadsStore';
import { FaInfoCircle, FaPlus } from 'react-icons/fa';
import Btn from '../../../components/Btn/Btn';
import { useTranslation } from 'react-i18next';
import {
	TabsEnum,
	LeadsModalModeEnum,
	RoleEnum,
} from '../../../api/models/Enums';
import { useAuth } from '../../../hooks/useAuth';
import useModalStore from '../../../store/ModalStore';
import ToolTip from '../../../components/Tooltip/Tooltip';
import { useMemo } from 'react';
import '../../../pages/Leads/LeadsPage.scss';

const LeadsActions = () => {
	const { t } = useTranslation();
	const { activeTab, checkedLeads, currentUserIsRefDealer } = useLeadsStore();
	const { openModal } = useModalStore();
	const { userRole, userCanReassignLead } = useAuth();

	const canReassignLead = useMemo(() => {
		return (
			[RoleEnum.MASTER].includes(userRole) ||
			([
				RoleEnum.SALES,
				RoleEnum.SALES_DEALER,
				RoleEnum.SALES_INTERNAL,
			].includes(userRole) &&
				currentUserIsRefDealer) ||
			([RoleEnum.BACKOFFICE, RoleEnum.AREA_MANAGER].includes(userRole) &&
				userCanReassignLead)
		);
	}, [currentUserIsRefDealer, userCanReassignLead, userRole]);

  return (
    <Card style={{border: 0, borderRadius: 0}}>
      <Row className='px-3 py-3 d-flex justify-content-between'>
        <Col md={12} className='d-flex justify-content-end align-items-center'>
          {
            canReassignLead ? (
              <div className='d-flex justify-content-end align-items-center'>
                {checkedLeads.length === 0 && (
                  <small id="info-reassign-lead" className='text-muted ms-2 me-2'>
                    <FaInfoCircle size={18} />
                    <ToolTip
                      anchorId="info-reassign-lead"
                      content={`${t('info_reassign_lead')}. ${t('cannot_select_more_then_30_leads')}`}
                      className="default"
                    />
                  </small>
                )}
                <Btn
                  onClick={() => openModal(LeadsModalModeEnum.ASSIGN_SALE)}
                  style={{
                    minWidth: '180px',
                    opacity: checkedLeads.length === 0 ? 0.5 : 1,
                    cursor: checkedLeads.length === 0 ? 'not-allowed' : 'pointer'
                  }}
                  className='me-3'
                  id="info-reassign-lead"
                  disabled={checkedLeads.length === 0}
                >
                  <FaPlus style={{ fontSize: '20px', marginRight: '3px', marginBottom: '3px' }} />
                  {t('reassign_lead')}
                </Btn>
              </div>
            ) : null
          }

					{activeTab === TabsEnum.NEW_LEADS && (
						<Btn
							onClick={() => openModal(LeadsModalModeEnum.CREATE_NEW_LEAD)}
							style={{ minWidth: '180px' }}
						>
							<FaPlus
								style={{
									fontSize: '20px',
									marginRight: '3px',
									marginBottom: '3px',
								}}
							/>
							{t('add_lead')}
						</Btn>
					)}
				</Col>
			</Row>
		</Card>
	);
};

export default LeadsActions;
